import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const toast = ({ type = "info", title = "", message = "" }) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: type,
    title: title,
    text: message,
    customClass: {
      popup: "swal2-toast-offset",
    },
  });
};

export default toast;
